import styled from 'styled-components';
export const Countdown = styled.p `
    display: inline-block;
    margin-left: 16px;
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
`;
//# sourceMappingURL=index.js.map